import { render, staticRenderFns } from "./send.vue?vue&type=template&id=630a1b88&"
import script from "./send.vue?vue&type=script&lang=js&"
export * from "./send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630a1b88')) {
      api.createRecord('630a1b88', component.options)
    } else {
      api.reload('630a1b88', component.options)
    }
    module.hot.accept("./send.vue?vue&type=template&id=630a1b88&", function () {
      api.rerender('630a1b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/page-argu/send.vue"
export default component.exports